import "izitoast/dist/css/iziToast.min.css";
import React from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { Button, CustomProvider, Modal } from "rsuite";
import "rsuite/";
import "rsuite/dist/rsuite.min.css";
import { ptBR } from "rsuite/esm/locales";
import {
  AuthContext,
  ModuleContext,
  UserContext,
} from "./components/authProvider/main";
import { PrettyError } from "./components/pretty-error/main";
import ProtectedRoute from "./components/protectedRoute/main";
import Sidebar from "./components/sidebar/main";
import Topbar from "./components/topbar/main";
import LoginPage from "./pages/LoginPage";
import ResetPassword from "./pages/ResetPassword";
import DashboardRoutes from "./pages/routes/DashboardRoutes";
import SetPasswordPage from "./pages/SetPasswordPage";
import "./style/App.css";
import "./style/rsuite-5.css";
import "./style/rsuite.css";
import axios from "./utilities/axios";
import { onError } from "./utilities/errorHandler";

export class App extends React.Component<any, {}> {
  public state: any = {
    hasError: false,
    errorMessage: "",
    hiddenSidebar:
      localStorage.getItem("hiddenSidebar") === "true" ? true : false,
    auth: {
      token: localStorage.getItem("token") ? localStorage.getItem("token") : null,
      isAuthenticated: localStorage.getItem("token") ? true : false,
      setAuth: (token: string | null) => {
        if (token === null) {
          localStorage.removeItem("token");
          localStorage.removeItem("modules");
          localStorage.removeItem("rolesUser");
          this.setState(
            (old: any) => {
              var newModule = { ...old.auth };
              newModule.token = token;
              newModule.isAuthenticated = false;
              return { auth: newModule };
            },
            () => {
              this.state.user.setUser(null);
            }
          );
        } else {
          localStorage.setItem("token", token);
          this.setState(
            (old: any) => {
              var newModule = { ...old.auth };
              newModule.token = token;
              newModule.isAuthenticated = true;
              return { auth: newModule };
            },
            () => {
              axios
                .get("/api/v1/me")
                .then((res) => {
                  if (res.data && res.data.user) {
                    localStorage.setItem("modules",JSON.stringify(res.data.user.modulesReturn));
                    this.state.user.setUser(res.data.user);

                    const storage = localStorage.getItem('rolesUser');
                      
                    if (storage){
                       localStorage.removeItem('rolesUser');
                    }
                    
                    localStorage.setItem('rolesUser', JSON.stringify(res.data.user.role.role_permissions));

                  }
                })
                .catch((e) => {
                  this.state.user.setUser(null);
                });
            }
          );
        }
      },
    },
    user: {
      data: null,
      setUser: (data: any) => {
        this.setState((old: any) => {
          var newModule = { ...old.user };
          newModule.data = data;
          return { user: newModule };
        });
      },
    },
    module: {
      name: null,
      crud: null,
      page: null,
      color: null,
      setPage: (name: string | null = null) => {
        this.setState((old: any) => {
          var newModule = { ...old.module };
          if (name != null) {
            newModule.page = name;
          }
          return { module: newModule };
        });
      },
      setModule: (
        name: string | null = null,
        color: string | null = null,
        crud = null
      ) => {
        this.setState((old: any) => {
          var newModule = { ...old.module };
          if (name != null) {
            newModule.name = name;
          }
          if (color) {
            newModule.color = color;
          }
          if (crud) {
            newModule.crud = crud;
          }
          return { module: newModule };
        });
      },
    },
  };
  
  private intervalId: NodeJS.Timeout | null = null;

  startTokenChecker = (): void => {
    const checkTokenRecursively = () => {
      if (window.location.pathname !== '/login') {
        this.checkToken();
        this.intervalId = setTimeout(checkTokenRecursively, 10000); 
      } else {
        this.stopTokenChecker();
      }
    };

    checkTokenRecursively(); 
  };

  stopTokenChecker = (): void => {
    if (this.intervalId) {
      clearTimeout(this.intervalId);
      this.intervalId = null;
    }
  };

  checkToken = (): void => {
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = '/login';
    }
  };

  componentDidMount() {
    if (this.state.auth.token != null) {
      this.state.auth.setAuth(this.state.auth.token);
    }
    onError("teste", (err: any) => {
      this.setState({ hasError: true, errorMessage: err.data });
    });
  };

  componentWillUnmount() {
    this.stopTokenChecker();
  };
  

  render() {
    return (
      <CustomProvider locale={ptBR}>
        <div>
          <Modal open={this.state.hasError} size={"md"}>
            <Modal.Body>
              <PrettyError error={this.state.errorMessage} />
            </Modal.Body>
            <Modal.Footer className="mt-4">
              <Button onClick={() => this.setState({ hasError: false })}>
                Fechar
              </Button>
            </Modal.Footer>
          </Modal>
          <Router>
            <AuthContext.Provider value={this.state.auth}>
              <ModuleContext.Provider value={this.state.module}>
                <UserContext.Provider value={this.state.user}>
                  <Sidebar hiddenSidebar={this.state.hiddenSidebar} />
                  {!window.location.pathname.includes('/checklist') && (
                    <Topbar
                      hiddenSidebar={this.state.hiddenSidebar}
                      changeSidebar={() => {
                        this.setState({
                          hiddenSidebar: !this.state.hiddenSidebar,
                        });
                        localStorage.setItem("hiddenSidebar", (!this.state.hiddenSidebar)?.toString());
                      }}
                    />
                  )}
                  <Switch>
                    <Route path="/" exact component={LoginPage} />
                    <Route exact path="/" component={LoginPage} />
                    <Route exact path="/login" component={LoginPage} />
                    <Route exact path="/setpassword" component={SetPasswordPage} />
                    <Route exact path="/resetpassword" component={ResetPassword} />
                    <ProtectedRoute hiddenSidebar={this.state.hiddenSidebar} path="/dashboard" component={DashboardRoutes} />
                  </Switch>
                </UserContext.Provider>
              </ModuleContext.Provider>
            </AuthContext.Provider>
          </Router>
        </div>
      </CustomProvider>
    );
    
  }
}
